import React, {Fragment} from 'react';
import PageTitle from '../../components/pagetitle/PageTitle'
import Contactpage from '../../components/Contactpage/Contactpage'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';
import Navbar from '../../components/Navbar/Navbar'
import Logo from '../../images/NewWFCOLogo2.svg'

import { homepgNavbarData } from '../../data/data';
import { homepgFooterData } from '../../data/data';

const ContactPage = () => {
    return(
        <Fragment>
            <Navbar hclass={'wpo-site-header-s1'} topbarNone={'topbar-none'} Logo={Logo} data={homepgNavbarData}/>
            <PageTitle pageTitle={'Contact Us'} pagesub={'Contact'}/> 
            <Contactpage/>
            <Footer logo={Logo} data={homepgFooterData}/>
            <Scrollbar/>
        </Fragment>
    )
};
export default ContactPage;

